import { css } from 'styled-components';
import '../constants/colors.js';
import '../constants/fonts.js';
import { Breakpoint } from '../constants/breakpoint.js';
import '../constants/theme.js';
import '../constants/files.js';
import '../constants/color-variant.js';
import '../constants/zIndexList.js';

const getMobileCSS = (template) => {
    return css `
        @media (max-width: ${Breakpoint.mobileBreakpointMaxWidth}) {
            ${template}
        }
    `;
};

export { getMobileCSS };
//# sourceMappingURL=getMobileCSS.js.map
